module.exports = __webpack_public_path__ + "static/media/17UN-Women1.d9ff63c9.jpg";